import React from "react";

import "../styles.scss";
import "../scripts";

import {
  widgetBlock,
  KameleonElement,
  getDefaultProps,
  MenuItem,
  BlockType,
} from "@kameleon-core/lib";

import { Link } from "@kameleon-common/gatsby-link";
import { Variants } from "@kameleon-util/global-theme";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { SitemapType, layoutOptions } from "./types/prop-types";

export const Sitemap = widgetBlock<SitemapType>(
  BlockType.FooterWidget,
  ({ title, menu }: SitemapType) => (
    <div className="footer-widget-sitemap-one-col-title-v1 ">
      <div className="footer5_link-list">
        <Variants.Heading
          as="h5"
          className="margin-bottom margin-xsmall footer5_label"
        >
          {title}
        </Variants.Heading>
        {menu.map((item: MenuItem, i: number) => {
          const key = `footer_link--${i}`;
          return (
            <Link key={key} to={item.link} className="footer5_link">
              {item.label}
            </Link>
          );
        })}
      </div>
    </div>
  )
);

Sitemap.defaultProps = getDefaultProps<SitemapType>(defaults);

export const Element: KameleonElement = {
  component: Sitemap,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
